export interface PkPluckProps {
    keyToMap: string
  }
  